 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import FOREWORDCONFESSIONSOFAWEIRDKID from '@/components/forewordconfessionsofaweirdkid'
 import IMPRISONEDWITHTHEPHARAOHS from '@/components/imprisonedwiththepharaohs'
 import THETHINGOFATHOUSANDSHAPES from '@/components/thethingofathousandshapes'
 import THEMAGICMIRROR from '@/components/themagicmirror'
 import THEVOWONHALLOWEEN from '@/components/thevowonhalloween'
 import THEWEREWOLFOFSTBONNOT from '@/components/thewerewolfofstbonnot'
 import THESEATHING from '@/components/theseathing'
 import SLEIGHBELLS from '@/components/sleighbells'
 import THEFESTIVAL from '@/components/thefestival'
 import THEWEREWOLFOFPONKERT from '@/components/thewerewolfofponkert'
 import VALEOFTHECORBIES from '@/components/valeofthecorbies'
 import THETENANTSOFBROUSSAC from '@/components/thetenantsofbroussac'
 import THEPHANTOMWOLFHOUND from '@/components/thephantomwolfhound'
 import THEGARGOYLE from '@/components/thegargoyle'
 import LOVE_2 from '@/components/love_2'
 import ORIGINALPUBLICATIONINFORMATION from '@/components/originalpublicationinformation'
 import ABOUTTHEEDITORS from '@/components/abouttheeditors'
 import IFYOULIKED from '@/components/ifyouliked'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/forewordconfessionsofaweirdkid",
 			"name" : "forewordconfessionsofaweirdkid",
 			"component" : FOREWORDCONFESSIONSOFAWEIRDKID
 		},
 		{
 			"path" : "/imprisonedwiththepharaohs",
 			"name" : "imprisonedwiththepharaohs",
 			"component" : IMPRISONEDWITHTHEPHARAOHS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js